module.exports = __webpack_public_path__ + "img/40.1f22741f.png";